/* UGC Scroller — Continuous auto-scroll reel using rAF */
(function() {
  'use strict';

  var reel = document.querySelector('[data-ugc-reel]');
  if (!reel) return;

  var track = reel.querySelector('[data-ugc-track]');
  if (!track) return;

  var speed = 0.5; /* pixels per frame */
  var pos = 0;
  var rafId;

  function scroll() {
    pos += speed;
    /* Reset when we've scrolled past half (since items are duplicated) */
    var halfWidth = track.scrollWidth / 2;
    if (pos >= halfWidth) pos = 0;
    track.style.transform = 'translateX(-' + pos + 'px)';
    rafId = requestAnimationFrame(scroll);
  }

  /* Start only when visible */
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        rafId = requestAnimationFrame(scroll);
      } else {
        cancelAnimationFrame(rafId);
      }
    });
  }, { threshold: 0.1 });

  observer.observe(reel);
})();
